'use client';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { getProps } from './core.utils.js';
import { renderElem } from './render-element.util.js';
import { renderWithRef } from './render-with-ref.js';

function createComponent({ propTypes: n, displayName: m, root: i, propConfig: l, requiredStyleKeys: p = [], propKeysToRemove: s = n ? Object.keys(n) : null }) {
    return renderWithRef(m, n, (t, n)=>{
        useComponentStylesLoaded(m, p);
        let { props: u, wrapRoot: c, children: f, processedProps: d } = getProps(t, l, s), a = renderElem({
            root: i,
            ref: n,
            renderProps: d,
            props: u,
            children: f
        });
        return c ? c(a) : a;
    });
}

export { createComponent };
